<template>
  <div class="menu-item">
    <slot></slot>
  </div>
</template>